import React, { useState } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import AzureStorageTable from './AzureStorageTable';
import { API_ENDPOINTS } from '../../../constants/apiEndpoints';
import { useAuth } from '../../../context/AuthContext';

const AzureStoragePage = () => {
  const { apiFetch } = useAuth();
  const [refresh, setRefresh] = useState(false);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleRefresh = () => {
    setRefresh(prev => !prev);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setUploading(true);
      await apiFetch(API_ENDPOINTS.AZURE_STORAGE_UPLOAD, {
        method: 'POST',
        body: formData,
      });
      setFile(null);
      handleRefresh();
    } catch (error) {
      console.error('Upload failed', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box component="main" sx={{ mt: 4 }}>
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          padding: 3,
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          marginTop: '50px',
          marginBottom: 4,
          textAlign: 'center',
          transition: 'transform 0.3s ease, boxShadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        <Typography variant="h4" sx={{ mb: 2, color: 'primary.main' }}>
          Azure Storage Manager
        </Typography>

        <Paper sx={{ padding: 3, mb: 4 }}>
          <input
            type="file"
            onChange={handleFileChange}
            style={{ marginRight: '16px' }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            disabled={!file || uploading}
            sx={{ mr: 2 }}
          >
            {uploading ? 'Uploading...' : 'Upload File'}
          </Button>
          <Button variant="outlined" onClick={handleRefresh}>
            Refresh Blob List
          </Button>
        </Paper>

        <Paper sx={{ padding: 3 }}>
          <AzureStorageTable refresh={refresh} />
        </Paper>
      </Box>
    </Box>
  );
};

export default AzureStoragePage;